<template>

    <button
        class="button"
        :class="[
            { '--purple': purple },
            { '--black': black },
            { '--large': large },
        ]" @click="goToRoute">

        <span class="flex items-center justify-center h-full">

            <div v-if="isLoading" class="ml-2">
                <Spinner/>
            </div>

            <span v-else class="flex items-center justify-center h-full">
                <slot/>
            </span>

        </span>

    </button>

</template>

<script lang="ts">

    import { defineComponent, PropType } from 'vue'
    import { RouteLocation, useRouter } from 'vue-router'
    import Spinner from './Spinner.vue'
    import { useTranslation } from '../compositions/UseTranslation'
    import { Locale } from '../enums/Locale'

    export default defineComponent({
        name: 'Button',
        components: {
            Spinner
        },
        props: {
            large: { type: Boolean, default: false },
            purple: { type: Boolean, default: false },
            black: { type: Boolean, default: false },
            isLoading: { type: Boolean, default: false },
            route: { type: [ Object, String ] as PropType<RouteLocation | string>, required: false }
        },
        setup(props) {

            const { isCNLocale } = useTranslation()
            const router = useRouter()

            return {
                goToRoute() {

                    if (props.route) {

                        const name = props.route.name
                        const parameters = props.route.params
                        const locale = isCNLocale ? Locale.CHINESE : ''
                        const routeName = name || props.route

                        router.push({ name: routeName, params: { locale, ...parameters } })

                    }

                }
            }

        }
    })

</script>

<style lang="scss">

    @include component(button) {

        @apply flex items-center justify-center text-center text-base font-bold leading-none w-full;

        height: 56px;
        padding: 0 30px;
        overflow: hidden;
        white-space: nowrap;
        transition: background-color 250ms ease, color 250ms ease;

        @screen md {

            max-width: none;
            padding: 0 52px;

        }

        &:focus {

            @apply outline-none;

        }

        @include option(large) {

            @screen md {

                @apply text-lg;

                height: 75px;

            }

        }

        @include option(purple) {

            color: #C000AF !important;
            border: solid 1px #C000AF !important;

            &:hover {

                color: #F5EAFE !important;
                background: #C000AF !important;

            }

        }

        @include option(black) {

            @apply bg-pure-black;

            color: #FBA7F2 !important;
            border: none;

            &:hover {

                color: #C000AF !important;
                background: #FFEDFD !important;
                border: none;

            }

        }

    }

</style>
